angular.module('mercury.modules.stock.invoices')
.factory('Invoices', ["$resource", "settings", function($resource, settings) {
  var ReceivedInvoicesByDateRange = $resource(`${settings.stockHost}/internal/invoices`)
  var Invoice = $resource(`${settings.stockHost}/invoices/:id`, {Id: '@id'})

  /**
   * Gets all invoices received within the given time period
   * @param {string} from the starting timestamp to retrieve received invoices from
   * @param {string} to the ending timetamp to retrieve received invoices to
   * @param {string} property the property to search between (e.g. Received, Created, Invoiced)
   * @returns A list of all invoices that were recieved in the given period 
   */
  function getReceivedInvoicesByDateRange(from, to, property) {
    return ReceivedInvoicesByDateRange.query({
      from,
      to,
      property,
      receivedOnly: true
    });
  }

  /**
   * Get a particular invoice
   * @param {string} id teh id of the invoice
   * @returns the invoice with the given id 
   */
  const getInvoice = (id) => Invoice.get({id: id})

  return {
    getReceivedInvoicesByDateRange,
    getInvoice
  };
}]);